import "./studentHero.css";

import { FadeIn } from "../../ui/fade-in";

const SIGNUP_URL = "https://app.raincareers.com/auth?mode=signUp";

/* Copy only. The schedule that used to sit under this now lives in the
   pinned stage below, so there is one of it on the page rather than two —
   it stays put while the section around it changes. The copy steps in on the
   same header entrance the ambassador, about and pricing pages use. */
const StudentHero = () => (
  <section className="s-hero">
    <div className="home-container s-hero-copy">
      <FadeIn delay={0}>
        <p className="s-hero-eyebrow">RAIN for job seekers</p>
      </FadeIn>

      <FadeIn delay={0.1}>
        <h1 className="s-hero-title">
          Where your job search{" "}
          <br className="br-wide" />
          finally has a plan
        </h1>
      </FadeIn>

      <FadeIn delay={0.2}>
        <p className="s-hero-sub">
          Applications, networking, and interview prep in one place, with
          RAIN telling you what to do next.
        </p>
      </FadeIn>

      {/* "Sign up free" rather than "Start your search": the free plan on the
          pricing page is open to anyone, not only students at partner
          schools. */}
      <FadeIn delay={0.3}>
        <a className="s-hero-btn" href={SIGNUP_URL}>
          Sign up free
        </a>
      </FadeIn>
    </div>
  </section>
);

export default StudentHero;
